import { BasePermission, ClientPermission, ClientUser } from "../api/types_common";
import { Company } from ".";

export interface EditedUser {
  rawUser: ListUser | null;
  displayName: string;
  email: string;
  emailVerified: boolean;
  changePassword: boolean;
  newPassword: string;
  disabled: boolean;
  allPermissions: EditedPermission[];
  curPermission: string;
}

export interface EditedPermission extends BasePermission {
  rawUser: ListUser | null;
  company: Company;
  branchIDs: number[];
}

export interface ListUser extends BasePermission {
  uid: string;
  isGlobalAdmin: boolean;
  displayName: string;
  email: string;
  emailVerified: boolean;
  disabled: boolean;
  lastSignInTimeUTC?: string;
  permissions: ClientPermission[];
  // Flattened permission
  companyID: number;
  isToken?: boolean;
  branchIDs?: number[];
  // ... also properties from BasePermission
  permissionScore: number;
  // Added
  company: Company;
  companyName: string;
  originalUser: ClientUser;
  allUsers: ListUser[];
}

export function emptyCompany(): Company {
  return { id: -1, name: "[No encontrada]", address: [], branchesSummaries: [] };
}
